<template>
  <div id="app" :class="[ hasDarkTheme ? 'darkMode': '' ]">
    <!-- The base component that the application is rendered inside of -->
    <div id="wrap">
      <top-navbar/>
      <!-- Self signup stuff -->
      <notifications v-if="isSignup" class="ssu-alert-container"/>
      <signup class="signup" v-if="isSignup"/>
      <bottom-navbar v-if="subNavbarVisible"/>

      <!-- Main app container -->
      <div v-if="!isSignup" class="container app" :class="visibilityClass">
        <notifications/>
        <notices/>
        <refresh-password-modal/>
        <!-- Where the current component is rendered -->
        <router-view/>
      </div>
    </div>
    <foot v-if="!isSignup"/>
  </div>
</template>

<style scoped>
  #app {
    height:100%;
  }

  #wrap > .container {
    padding: 150px 15px 0;
    min-height: calc(100vh - 358px);
  }

  .signup {
    min-height: calc(100vh - 298px);
  }

  .ssu-alert-container {
    padding: 0;
    left: 50%;
    transform: translate(-50%);
  }

</style>

<script>
  import TopNavbar from './components/TopNavbar'
  import BottomNavbar from './components/BottomNavbar'
  import Foot from './components/Foot'
  import Notifications from './components/Notifications'
  import { mapState, mapGetters } from 'vuex'
  import Notices from './components/Notices'
  import RefreshPasswordModal from './components/Modals/RefreshPasswordModal';
  import * as types from './store/mutation-types'
  import Signup from './pages/Signup.vue'

  export default {
    mounted () {
      this.checkTheme()
    },

    computed: {
      isSignup () {
        return this.$route.name === 'signup'
      },
      // Show the sub navbar if not the login page
      subNavbarVisible () {
        return this.loggedIn
      },
      // Position the container correctly based on if subnavbar is visible
      visibilityClass () {
        return this.subNavbarVisible ? 'visible-subnav' : 'invisible-subnav'
      },
      ...mapGetters([
       'hasDarkTheme'
      ]),
      ...mapState({
        notifications: state => state.notifications.messages,
        loggedIn: state => state.user.loggedIn,
      })
    },

    methods: {
      checkTheme () {
        // check browser preferences
        if (this.hasDarkTheme !== null) {
          this.hasDarkTheme ? this.$store.dispatch('setDarkTheme') : this.$store.dispatch('setLightTheme');
        }
        else if ((this.hasDarkTheme === null) && (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
          this.$store.dispatch('setDarkTheme');
        }
        else {
          this.$store.dispatch('setLightTheme');
        }
      }
    },

    components: {
      TopNavbar,
      BottomNavbar,
      Foot,
      Notifications,
      Notices,
      RefreshPasswordModal,
      Signup
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?1c6d7375